module.exports = __webpack_public_path__ + "img/jiaoxue_heroes_score_bg.a1525018.png";